import { Nav } from "react-bootstrap";
import { useSessionState } from "../../hooks/useSessionState";
import { useUserState } from "../../hooks/useUserState";
import IconWithBadge from "../badges/IconWithBadge";

export default function NavControls() {
	const { session, signOut } = useSessionState();
	const { user } = useUserState();

	return (
		session.isAuthenticated ? (
			<>
				<Nav.Link href="/stories">Stories</Nav.Link>
				<Nav.Link href="/orders">Orders</Nav.Link>
				<Nav.Link href="/cart">
					Cart <IconWithBadge iconName="BsCart3" count={user?.getCountByKeyFilter((key) => key.startsWith("CartItem"))} />
				</Nav.Link>
				<Nav.Link href="/account">Account</Nav.Link>
				<Nav.Link onClick={signOut}>Logout</Nav.Link>
			</>
		) : (
			<>
				<Nav.Link href="/how-it-works">How it works</Nav.Link>
				<Nav.Link href="/showcase">Showcase</Nav.Link>
				<Nav.Link href="/pricing">Pricing</Nav.Link>
				<Nav.Link href="/signup">Signup</Nav.Link>
				<Nav.Link href="/login">Login</Nav.Link>
			</>
		)
	);
}
